export default __webpack_public_path__ + "48e42a3426b2a3a8bf7c4f5f97e2f58a.png";